var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchDarkMedium = function SvgSearchDarkMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    fillRule: "evenodd",
    d: "M9.167 3.333a5.833 5.833 0 1 0 0 11.667 5.833 5.833 0 0 0 0-11.667m-7.5 5.834a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    fillRule: "evenodd",
    d: "M13.286 13.286a.833.833 0 0 1 1.178 0l3.625 3.625a.833.833 0 1 1-1.178 1.178l-3.625-3.625a.833.833 0 0 1 0-1.178",
    clipRule: "evenodd"
  })));
};
export default SvgSearchDarkMedium;